(function () {
  if (window.customElements && customElements.get('logo-preview-component')) return;

  function hexA(hex, a) {
    hex = (hex || '#ffffff').replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var r = parseInt(hex.substr(0, 2), 16) || 0;
    var g = parseInt(hex.substr(2, 2), 16) || 0;
    var b = parseInt(hex.substr(4, 2), 16) || 0;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
  }

  function rgbaStr(rgb, a) {
    var m = (rgb || '').match(/(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/);
    if (!m) return hexA(rgb, a);
    return 'rgba(' + m[1] + ',' + m[2] + ',' + m[3] + ',' + a + ')';
  }

  function shadeHex(hex, amt) {
    hex = (hex || '#1a1a1a').replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var r = Math.max(0, Math.min(255, (parseInt(hex.substr(0, 2), 16) || 0) + amt));
    var g = Math.max(0, Math.min(255, (parseInt(hex.substr(2, 2), 16) || 0) + amt));
    var b = Math.max(0, Math.min(255, (parseInt(hex.substr(4, 2), 16) || 0) + amt));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }

  function roundRect(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  // Remove a solid background from non-transparent uploads, then crop the
  // result to the logo's actual bounds so there is no baked-in empty margin.
  function processImage(img) {
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    if (!w || !h) return img;
    var scale = Math.min(1, 1200 / Math.max(w, h));
    var cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(h * scale));
    var c = document.createElement('canvas'); c.width = cw; c.height = ch;
    var x = c.getContext('2d');
    x.drawImage(img, 0, 0, cw, ch);
    var id;
    try { id = x.getImageData(0, 0, cw, ch); } catch (e) { return c; }
    var d = id.data;
    var hasAlpha = false;
    for (var i = 3; i < d.length; i += 4) { if (d[i] < 250) { hasAlpha = true; break; } }
    if (!hasAlpha) {
      var corner = function (ix, iy) { var o = (iy * cw + ix) * 4; return [d[o], d[o + 1], d[o + 2]]; };
      var cs = [corner(0, 0), corner(cw - 1, 0), corner(0, ch - 1), corner(cw - 1, ch - 1)];
      var bg = [0, 0, 0];
      for (var j = 0; j < 4; j++) { bg[0] += cs[j][0]; bg[1] += cs[j][1]; bg[2] += cs[j][2]; }
      bg[0] /= 4; bg[1] /= 4; bg[2] /= 4;
      var tol = 46;
      // Global colour-key: ANY pixel close to the logo's background colour
      // becomes transparent, including the enclosed counters inside letters
      // and symbols (the holes in R, A, D, O, the atom, etc.). This lets the
      // lit face show through those pockets so they match the face instead of
      // staying pure white. Soft edges get partial alpha so there is no halo.
      var inner = tol * 0.6;
      for (var o = 0; o < d.length; o += 4) {
        var dr = d[o] - bg[0], dg = d[o + 1] - bg[1], db = d[o + 2] - bg[2];
        var dist = Math.sqrt(dr * dr + dg * dg + db * db);
        if (dist < inner) {
          d[o + 3] = 0;
        } else if (dist < tol) {
          var a = (dist - inner) / (tol - inner);
          var cur = d[o + 3] / 255;
          d[o + 3] = Math.round(255 * Math.min(cur, a));
        }
      }
      x.putImageData(id, 0, 0);
      try { id = x.getImageData(0, 0, cw, ch); d = id.data; } catch (e) { return c; }
    }
    // Clear near-white opaque "paper" everywhere (runs for transparent PNGs too,
    // not just flat uploads): enclosed counters inside letters and symbols
    // (holes in R, A, D, O, the atom, etc.) are often filled solid white in the
    // source file. Making them transparent lets the lit sign face show through,
    // so they match the surrounding face and track the brightness slider.
    for (var p2 = 0; p2 < d.length; p2 += 4) {
      if (d[p2 + 3] < 10) continue;
      var R2 = d[p2], G2 = d[p2 + 1], B2 = d[p2 + 2];
      var mx2 = Math.max(R2, G2, B2), mn2 = Math.min(R2, G2, B2);
      var sat2 = mx2 === 0 ? 0 : (mx2 - mn2) / mx2;
      var lum2 = (R2 + G2 + B2) / 3;
      if (sat2 < 0.12 && lum2 >= 236) {
        d[p2 + 3] = 0;
      } else if (sat2 < 0.12 && lum2 >= 220) {
        var f2 = (236 - lum2) / 16; // 1 at lum 220 -> 0 at lum 236 (soft edge)
        d[p2 + 3] = Math.round(d[p2 + 3] * f2);
      }
    }
    x.putImageData(id, 0, 0);
    try { id = x.getImageData(0, 0, cw, ch); d = id.data; } catch (e) { return c; }
    // crop to non-transparent bounds (removes empty margins)
    var minx = cw, miny = ch, maxx = -1, maxy = -1;
    for (var yy = 0; yy < ch; yy++) {
      for (var xx = 0; xx < cw; xx++) {
        if (d[(yy * cw + xx) * 4 + 3] > 12) {
          if (xx < minx) minx = xx;
          if (xx > maxx) maxx = xx;
          if (yy < miny) miny = yy;
          if (yy > maxy) maxy = yy;
        }
      }
    }
    if (maxx < minx || maxy < miny) return c;
    var bw = maxx - minx + 1, bh = maxy - miny + 1;
    if (bw >= cw - 2 && bh >= ch - 2) return c;
    var t = document.createElement('canvas'); t.width = bw; t.height = bh;
    t.getContext('2d').drawImage(c, minx, miny, bw, bh, 0, 0, bw, bh);
    return t;
  }

  class LogoPreview extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('[data-lp-canvas]');
      if (!this.canvas) return;
      this.ctx = this.canvas.getContext('2d');
      this.fileInput = this.querySelector('[data-lp-file]');
      this.brightInput = this.querySelector('[data-lp-bright]');
      this.fileNameEl = this.querySelector('[data-lp-filename]');
      this.bgSwatchBtns = this.querySelectorAll('[data-lp-bg-swatch]');
      this.bgWidthInput = this.querySelector('[data-lp-bg-width]');
      this.bgColorProp = this.querySelector('[data-lp-bg-color-prop]');
      this.bgWidthProp = this.querySelector('[data-lp-bg-width-prop]');
      this.orientationGroup = this.querySelector('[data-lp-orientation-group]');
      this.orientationBtns = this.querySelectorAll('[data-lp-orientation]');
      this.orientationProp = this.querySelector('[data-lp-orientation-prop]');
      this.refreshBtn = this.querySelector('[data-lp-refresh]');
      this.glow = this.dataset.glow || '#ffd9a0';
      this.wall = this.dataset.wall || '#2e2e33';
      this.placeholder = this.dataset.placeholder || 'Your logo here';
      try { this.shapes = JSON.parse(this.dataset.variantShapes || '{}'); } catch (e) { this.shapes = {}; }
      try { this.optionShapes = JSON.parse(this.dataset.optionShapes || '{}'); } catch (e) { this.optionShapes = {}; }
      this.img = null;
      this._silCache = {};
      this._outlineCache = null;
      this.detectedPrimary = null;
      this.primary = this.glow;
      this.bright = parseInt((this.brightInput && this.brightInput.value) || this.dataset.brightness || '80', 10);
      // Background is now a fixed Black/White choice — read the swatch
      // marked active in the liquid template (server-rendered default)
      // rather than assuming a hex value.
      var activeSwatch = null;
      for (var bi0 = 0; this.bgSwatchBtns && bi0 < this.bgSwatchBtns.length; bi0++) {
        if (this.bgSwatchBtns[bi0].classList.contains('is-active')) { activeSwatch = this.bgSwatchBtns[bi0]; break; }
      }
      this.bgColor = (activeSwatch && activeSwatch.dataset.color) || '#ffffff';
      this.bgWidth = parseInt((this.bgWidthInput && this.bgWidthInput.value), 10);
      if (isNaN(this.bgWidth)) this.bgWidth = 3;
      if (this.bgWidthProp) this.bgWidthProp.value = this.bgWidth;
      this.orientation = 'horizontal';
      if (this.orientationProp) this.orientationProp.value = 'Horizontal';
      this.shape = this.currentShape();
      this.bindEvents();
      var self = this;
      requestAnimationFrame(function () { self.resize(); self.render(); });
    }

    disconnectedCallback() {
      if (this._onOptionSelect) {
        document.removeEventListener('shopify:product:select', this._onOptionSelect);
        document.removeEventListener('variant:update', this._onOptionSelect);
      }
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    bindEvents() {
      var self = this;
      if (this.fileInput) this.fileInput.addEventListener('change', function (e) { self.onFile(e); });
      if (this.brightInput) this.brightInput.addEventListener('input', function () { self.bright = parseInt(self.brightInput.value, 10); self.render(); });

      if (this.bgSwatchBtns && this.bgSwatchBtns.length) {
        for (var swi = 0; swi < this.bgSwatchBtns.length; swi++) {
          this.bgSwatchBtns[swi].addEventListener('click', function () {
            self.bgColor = this.dataset.color || '#ffffff';
            if (self.bgColorProp) self.bgColorProp.value = this.dataset.label || '';
            for (var swj = 0; swj < self.bgSwatchBtns.length; swj++) {
              self.bgSwatchBtns[swj].classList.toggle('is-active', self.bgSwatchBtns[swj] === this);
            }
            self.render();
          });
        }
      }
      if (this.bgWidthInput) {
        this.bgWidthInput.addEventListener('input', function () {
          self.bgWidth = parseInt(self.bgWidthInput.value, 10);
          if (self.bgWidthProp) self.bgWidthProp.value = self.bgWidth;
          self._outlineCache = null; // geometry depends on width — force a rebuild
          self.render();
        });
      }

      if (this.orientationBtns && this.orientationBtns.length) {
        for (var oi = 0; oi < this.orientationBtns.length; oi++) {
          this.orientationBtns[oi].addEventListener('click', function () {
            var val = this.dataset.lpOrientation; // 'horizontal' | 'vertical'
            self.orientation = val;
            for (var oj = 0; oj < self.orientationBtns.length; oj++) {
              self.orientationBtns[oj].classList.toggle('is-active', self.orientationBtns[oj] === this);
            }
            if (self.orientationProp) self.orientationProp.value = val === 'vertical' ? 'Vertical' : 'Horizontal';
            self.render();
          });
        }
      }

      // Shape selection: Horizon's variant-picker dispatches
      // "shopify:product:select" with { optionValueId } — it does NOT include
      // a variant id, and the older "variant:update" (resource.id) event this
      // previously relied on is no longer fired by the current theme version.
      // When the changed value belongs to the Shape option, we know the exact
      // new shape immediately and render right away — the hidden variant-id
      // input on the page hasn't been updated by Shopify yet at this point,
      // so falling through to a currentShape() re-check here would read the
      // OLD value and overwrite the correct shape we just set (this caused a
      // one-click-behind bug: selecting a shape appeared to do nothing, and
      // the previous shape would only appear after the *next* click).
      // For anything else, fall back to re-checking the variant id shortly
      // after, so state still stays in sync if Shopify's own update lands late.
      this._onOptionSelect = function (e) {
        var ovId = e && e.detail && e.detail.optionValueId;
        if (ovId != null && self.optionShapes[String(ovId)]) {
          self.shape = self.norm(self.optionShapes[String(ovId)]);
          self.render();
          return;
        }
        requestAnimationFrame(function () {
          var next = self.currentShape();
          if (next !== self.shape) self.shape = next;
          self.render();
        });
      };
      document.addEventListener('shopify:product:select', this._onOptionSelect);
      document.addEventListener('variant:update', this._onOptionSelect);

      if (this.refreshBtn) {
        this.refreshBtn.addEventListener('click', function () {
          // Force a full re-sync with whatever is currently selected, in case
          // a variant-change event was missed or arrived late.
          self.shape = self.currentShape();
          self.render();
          self.refreshBtn.classList.remove('is-spinning');
          // restart the animation even on rapid repeat clicks
          void self.refreshBtn.offsetWidth;
          self.refreshBtn.classList.add('is-spinning');
        });
      }

      this._onResize = function () { self.resize(); self.render(); };
      window.addEventListener('resize', this._onResize);
    }

    currentShape() {
      var sec = this.closest('.shopify-section') || document;
      var idInput = sec.querySelector('input[name="id"]');
      var id = idInput && idInput.value;
      if (id && this.shapes[id]) return this.norm(this.shapes[id]);
      var keys = Object.keys(this.shapes);
      return this.norm(keys.length ? this.shapes[keys[0]] : 'round');
    }

    // Show the Horizontal/Vertical toggle only for the two shapes where flipping
    // the aspect ratio actually makes sense (Round is symmetric, Square already
    // is what it is, Logo Outline follows the logo's own silhouette).
    updateOrientationVisibility() {
      if (!this.orientationGroup) return;
      var show = (this.shape === 'oval' || this.shape === 'rect');
      this.orientationGroup.style.display = show ? '' : 'none';
    }

    norm(v) {
      v = (v || '').toString().toLowerCase();
      // Match both English and French option values:
      // Round/Ronde, Square/Carrée, Rectangular/Rectangulaire, Oval/Ovale, Logo Outline/Contour du logo.
      if (v.indexOf('outline') >= 0 || v.indexOf('contour') >= 0) return 'outline';
      if (v.indexOf('oval') >= 0 || v.indexOf('ovale') >= 0) return 'oval';
      if (v.indexOf('rect') >= 0) return 'rect';
      if (v.indexOf('square') >= 0 || v.indexOf('carr') >= 0) return 'square';
      if (v.indexOf('round') >= 0 || v.indexOf('rond') >= 0) return 'round';
      return 'round';
    }

    onFile(e) {
      var self = this;
      var f = e.target.files && e.target.files[0];
      if (this.fileNameEl) this.fileNameEl.textContent = f ? f.name : '';
      this._silCache = {};
      this._outlineCache = null;
      if (!f) { this.img = null; this.detectedPrimary = null; this.render(); return; }
      var url = URL.createObjectURL(f);
      var img = new Image();
      img.onload = function () {
        self.img = processImage(img);
        self._silCache = {};
        self._outlineCache = null;
        self.detectedPrimary = self.detectPrimary();
        self.render();
        URL.revokeObjectURL(url);
      };
      img.onerror = function () { self.img = null; self.detectedPrimary = null; self.render(); URL.revokeObjectURL(url); };
      img.src = url;
    }

    detectPrimary() {
      try {
        var w = 48, h = 48;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var x = c.getContext('2d'); x.drawImage(this.img, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data;
        var buckets = {};
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
          if (a < 128) continue;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
          var sat = mx === 0 ? 0 : (mx - mn) / mx;
          var lum = (r + g + b) / 3;
          if (sat < 0.35 || lum < 28 || lum > 236) continue;
          var hue;
          if (mx === mn) hue = 0;
          else if (mx === r) hue = (60 * ((g - b) / (mx - mn)) + 360) % 360;
          else if (mx === g) hue = 60 * ((b - r) / (mx - mn)) + 120;
          else hue = 60 * ((r - g) / (mx - mn)) + 240;
          var key = Math.round(hue / 18);
          var bk = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
          bk.n++; bk.r += r; bk.g += g; bk.b += b;
        }
        var best = null;
        for (var k in buckets) { if (!best || buckets[k].n > best.n) best = buckets[k]; }
        if (best && best.n > 4) {
          return 'rgb(' + Math.round(best.r / best.n) + ',' + Math.round(best.g / best.n) + ',' + Math.round(best.b / best.n) + ')';
        }
      } catch (e) {}
      // No strong colour found (e.g. a black/white/grey-only logo) — let the
      // caller fall back to the customer's chosen background colour instead of
      // a hardcoded accent, so the client controls the glow.
      return null;
    }

    coloredSil(color) {
      if (!this.img) return null;
      if (this._silCache[color]) return this._silCache[color];
      var w = this.img.naturalWidth || this.img.width, h = this.img.naturalHeight || this.img.height;
      if (!w || !h) return null;
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var x = c.getContext('2d');
      x.drawImage(this.img, 0, 0, w, h);
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = color;
      x.fillRect(0, 0, w, h);
      this._silCache[color] = c;
      return c;
    }

    resize() {
      var dpr = window.devicePixelRatio || 1;
      var w = this.canvas.clientWidth || 400;
      this.canvas.width = Math.round(w * dpr);
      this.canvas.height = Math.round(w * dpr);
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      this.size = w;
    }

    drawImgContain(img, x, y, w, h) {
      if (!img) return;
      var iw = img.naturalWidth || img.width;
      var ih = img.naturalHeight || img.height;
      if (!iw || !ih) return;
      var scale = Math.min(w / iw, h / ih);
      var dw = iw * scale, dh = ih * scale;
      this.ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
    }

    shapePath(shape, cx, cy, pw, ph, r) {
      var ctx = this.ctx;
      if (shape === 'round') { ctx.beginPath(); ctx.arc(cx, cy, pw / 2, 0, Math.PI * 2); }
      else if (shape === 'oval') { ctx.beginPath(); ctx.ellipse(cx, cy, pw / 2, ph / 2, 0, 0, Math.PI * 2); }
      else { roundRect(ctx, cx - pw / 2, cy - ph / 2, pw, ph, r); }
    }

    wallBackground(S, cx, cy) {
      var ctx = this.ctx;
      ctx.clearRect(0, 0, S, S);
      var wg = ctx.createRadialGradient(cx, cy, S * 0.06, cx, cy, S * 0.78);
      wg.addColorStop(0, shadeHex(this.wall, 14));
      wg.addColorStop(1, shadeHex(this.wall, -8));
      ctx.fillStyle = wg;
      ctx.fillRect(0, 0, S, S);
    }

    stripeColor(t) {
      if (t < 0.12) return { c: '#0e0e0e' };
      if (t < 0.30) return { c: '#f4f1ea', glow: true };
      if (t < 0.40) return { c: '#0e0e0e' };
      if (t < 0.58) return { c: 'PRIMARY', glow: true };
      return { c: '#0e0e0e' };
    }

    haloPass(shape, cx, cy, pw, ph, r, bf) {
      var ctx = this.ctx;
      ctx.save();
      ctx.shadowColor = rgbaStr(this.primary, 0.42 * bf + 0.16);
      ctx.shadowBlur = (this.size || 400) * 0.055;
      ctx.fillStyle = rgbaStr(this.primary, 0.3);
      this.shapePath(shape, cx, cy, pw, ph, r);
      ctx.fill();
      ctx.restore();
      ctx.save();
      ctx.shadowColor = hexA('#ffffff', 0.22 * bf + 0.08);
      ctx.shadowBlur = (this.size || 400) * 0.028;
      ctx.fillStyle = hexA('#ffffff', 0.18);
      this.shapePath(shape, cx, cy, pw, ph, r);
      ctx.fill();
      ctx.restore();
    }

    render() {
      var ctx = this.ctx, S = this.size || 400;
      if (!ctx) return;
      // Glow/accent colour: the logo's own dominant colour if one was detected;
      // otherwise (black/white/grey-only logos) let the customer's chosen
      // background colour drive the glow instead of a fixed accent, once an
      // image is uploaded. Before any upload, keep the default accent as a
      // neutral placeholder.
      this.primary = this.img ? (this.detectedPrimary || this.bgColor || this.glow) : this.glow;
      this.updateOrientationVisibility();
      var bf = Math.max(0, Math.min(1, this.bright / 100));
      var cx0 = S / 2, cy0 = S / 2;
      this.wallBackground(S, cx0, cy0);

      // Render the uploaded artwork exactly as-is — no colour reduction.
      // Our team hand-finishes gradients during production, so the on-screen
      // preview is a close guide rather than a pixel-exact match; see the
      // note below the canvas.
      var faceImg = this.img;

      var shape = this.shape, pw, ph, r;
      if (shape === 'round') { pw = ph = S * 0.50; r = pw / 2; }
      else if (shape === 'oval') { pw = S * 0.62; ph = S * 0.42; r = 0; }
      else if (shape === 'rect') { pw = S * 0.60; ph = S * 0.40; r = 8; }
      else if (shape === 'square') { pw = ph = S * 0.50; r = 10; }
      else { pw = ph = S * 0.54; r = 0; }

      // Customer-chosen orientation (Oval/Rectangular only): swap width/height so
      // the shape stands taller than it is wide, to match a portrait-oriented logo.
      if ((shape === 'oval' || shape === 'rect') && this.orientation === 'vertical') {
        var _swap = pw; pw = ph; ph = _swap;
      }

      var depth = Math.max(pw, ph) * 0.14;
      var dx = depth, dy = depth * 0.40;
      var cx = cx0 - dx * 0.42, cy = cy0 - dy * 0.42;

      if (shape === 'outline' && this.img) { this.renderOutline(cx, cy, S, bf, dx, dy, faceImg); return; }

      this.haloPass(shape, cx + dx * 0.5, cy + dy * 0.5, pw, ph, r, bf);

      ctx.save();
      ctx.fillStyle = 'rgba(0,0,0,0.38)';
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = S * 0.035;
      this.shapePath(shape, cx + dx + S * 0.012, cy + dy + S * 0.018, pw, ph, r);
      ctx.fill();
      ctx.restore();

      var STEPS = 56;
      for (var i = STEPS; i >= 1; i--) {
        var t = i / STEPS;
        var sc = this.stripeColor(t);
        var col = sc.c === 'PRIMARY' ? this.primary : sc.c;
        ctx.save();
        if (sc.glow) { ctx.shadowColor = rgbaStr(col, 0.30 + 0.4 * bf); ctx.shadowBlur = S * 0.012; }
        ctx.fillStyle = col;
        this.shapePath(shape, cx + dx * t, cy + dy * t, pw, ph, r);
        ctx.fill();
        ctx.restore();
      }

      ctx.save();
      this.shapePath(shape, cx, cy, pw, ph, r);
      ctx.clip();
      // Customer-chosen background (mat) colour behind the logo.
      var bgCol = this.bgColor || '#f6f3ec';
      var fg = ctx.createRadialGradient(cx, cy, pw * 0.04, cx, cy, pw * 0.72);
      fg.addColorStop(0, rgbaStr(shadeHex(bgCol, 10), 0.88 + 0.12 * bf));
      fg.addColorStop(1, rgbaStr(shadeHex(bgCol, -10), 0.82 + 0.16 * bf));
      ctx.fillStyle = fg;
      ctx.fillRect(cx - pw / 2 - 2, cy - ph / 2 - 2, pw + 4, ph + 4);
      if (faceImg) {
        // Customer-chosen background width: 0 = logo fills the shape edge-to-edge,
        // 10 = the mat takes up most of the shape and the logo sits small in the middle.
        var t2 = Math.max(0, Math.min(10, this.bgWidth || 0)) / 10;
        var iw, ih;
        if (shape === 'round') { iw = pw * (0.94 - 0.54 * t2); ih = ph * (0.94 - 0.54 * t2); }
        else if (shape === 'rect') { iw = pw * (0.96 - 0.41 * t2); ih = ph * (0.92 - 0.47 * t2); }
        else { iw = pw * (0.95 - 0.50 * t2); ih = ph * (0.95 - 0.50 * t2); }
        this.drawImgContain(faceImg, cx - iw / 2, cy - ih / 2, iw, ih);
      } else {
        ctx.fillStyle = 'rgba(60,60,60,0.5)';
        ctx.font = '500 ' + Math.round(S * 0.034) + 'px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(this.placeholder, cx, cy);
      }
      ctx.restore();
    }

    // Build (and cache) the connected "contour" panel for the outline shape:
    // the logo silhouette dilated (grown) by a radius large enough that adjacent
    // letters/symbols merge into ONE solid piece, so the lit lightbox wraps the
    // whole logo instead of leaving dark gaps between letters.
    buildOutline(box, faceImg) {
      var q = Math.max(1, Math.min(2, window.devicePixelRatio || 1)); // device res = crisp edges
      var bw = this.bgWidth || 0;
      var cacheKey = box + '|' + q + '|' + bw;
      if (this._outlineCache && this._outlineCache.key === cacheKey) return this._outlineCache;
      var pad = Math.round(box * 0.22);
      var MBcss = Math.round(box) + pad * 2;
      var MB = Math.round(MBcss * q);
      var mask = document.createElement('canvas'); mask.width = MB; mask.height = MB;
      var mc = mask.getContext('2d');
      mc.imageSmoothingEnabled = true; mc.imageSmoothingQuality = 'high';
      var srcImg = faceImg || this.img;
      var iw = srcImg.naturalWidth || srcImg.width, ih = srcImg.naturalHeight || srcImg.height;
      var fit = box * q;
      var sc = Math.min(fit / iw, fit / ih);
      var dw = iw * sc, dh = ih * sc;
      mc.drawImage(srcImg, (MB - dw) / 2, (MB - dh) / 2, dw, dh);
      // Snap faint leftover pixels (residue from imperfect background removal,
      // e.g. a soft highlight or anti-aliased edge that didn't fully clear) to
      // fully transparent. Without this, those pixels survive as a translucent
      // "ghost" blob once the hole-fill + background-colour panel render underneath
      // them — invisible against the old near-white default, but glaring against
      // a customer-chosen colour.
      try {
        var mid = mc.getImageData(0, 0, MB, MB);
        var mdat = mid.data;
        for (var mi = 3; mi < mdat.length; mi += 4) {
          if (mdat[mi] < 40) mdat[mi] = 0;
        }
        mc.putImageData(mid, 0, 0);
      } catch (e) {}
      // Panel growth = customer-controlled background width (also connects
      // adjacent letters/symbols into one solid piece so the mat wraps the
      // whole logo instead of leaving dark gaps between letters).
      var R = Math.max(8, Math.round(box * (0.045 + bw * 0.008) * q));
      var dil = this.smoothDilate(mask, R);
      this._outlineCache = { key: cacheKey, box: box, q: q, MBcss: MBcss, MB: MB, mask: mask, dil: dil, tint: {} };
      return this._outlineCache;
    }

    // Grow the silhouette by R, then blur + alpha-threshold at ~0.5 so the merged
    // contour comes out as smooth curves (removes the stair-step / zig-zag boundary
    // left by discrete stamping).
    smoothDilate(src, R) {
      var grown = this.dilate(src, R);
      var w = grown.width, h = grown.height;

      // Fill enclosed holes on the RAW dilated silhouette first, before any blur
      // touches it. Blurring first (the old order) softens the ring around small
      // holes into a gradient, and the flood-fill can leak through that soft edge
      // asymmetrically — leaving a partially-filled "ghost" patch with a ragged
      // border instead of a clean solid fill. Binarizing + hole-filling on the
      // crisp pre-blur silhouette guarantees any enclosed hole is fully sealed
      // before smoothing ever runs, regardless of how small it is.
      var gctx = grown.getContext('2d');
      var gid;
      try { gid = gctx.getImageData(0, 0, w, h); } catch (e) { gid = null; }
      if (gid) {
        var gd = gid.data;
        for (var gi = 3; gi < gd.length; gi += 4) { gd[gi] = gd[gi] >= 40 ? 255 : 0; }
        this.fillHoles(gd, w, h);
        gctx.putImageData(gid, 0, 0);
      }

      var b = document.createElement('canvas'); b.width = w; b.height = h;
      var bx = b.getContext('2d');
      var sb = Math.max(1.5, R * 0.55);
      bx.filter = 'blur(' + sb + 'px)';
      bx.drawImage(grown, 0, 0);
      bx.filter = 'none';
      var id;
      try { id = bx.getImageData(0, 0, w, h); } catch (e) { return grown; }
      var d = id.data, lo = 116, hi = 140;
      for (var i = 0; i < d.length; i += 4) {
        var a = d[i + 3];
        d[i + 3] = a <= lo ? 0 : (a >= hi ? 255 : Math.round((a - lo) / (hi - lo) * 255));
      }
      // Edges are already clean post-blur (no holes left to leak through), but
      // re-run as a cheap safety net in case blur introduced any new border gaps.
      this.fillHoles(d, w, h);
      bx.putImageData(id, 0, 0);
      return b;
    }

    // Verification pass for the contour panel: flood the OUTSIDE transparency in
    // from the canvas borders, then any transparent pixel that was never reached
    // is an enclosed hole (e.g. the negative space inside a triangle/ring logo).
    // Fill those so the lit lightbox is one solid piece with no empty gaps.
    fillHoles(d, w, h) {
      var n = w * h;
      var seen = new Uint8Array(n);
      var st = [];
      var push = function (x, y) {
        if (x < 0 || y < 0 || x >= w || y >= h) return;
        var p = y * w + x;
        if (seen[p] || d[p * 4 + 3] >= 128) return;
        seen[p] = 1; st.push(p);
      };
      var x, y;
      for (x = 0; x < w; x++) { push(x, 0); push(x, h - 1); }
      for (y = 0; y < h; y++) { push(0, y); push(w - 1, y); }
      while (st.length) {
        var p = st.pop(), px = p % w, py = (p - px) / w;
        push(px + 1, py); push(px - 1, py); push(px, py + 1); push(px, py - 1);
      }
      for (var q = 0; q < n; q++) { if (!seen[q] && d[q * 4 + 3] < 128) d[q * 4 + 3] = 255; }
    }

    // Morphological dilation of a canvas's alpha by radius R (Minkowski sum with a
    // disc) — stamps the shape around a ring of offsets and unions the coverage.
    dilate(src, R) {
      var w = src.width, h = src.height;
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d');
      var steps = 40, step = Math.max(1, R / 6);
      for (var k = 0; k < steps; k++) {
        var ang = k / steps * Math.PI * 2, ca = Math.cos(ang), sa = Math.sin(ang);
        for (var rr = R; rr >= 1; rr -= step) x.drawImage(src, ca * rr, sa * rr);
      }
      x.drawImage(src, 0, 0);
      return c;
    }

    // Fill a mask canvas's alpha with a flat colour (cached per shape+colour).
    outlineTint(cache, srcCanvas, color, key) {
      var ck = key + '|' + color;
      if (cache.tint[ck]) return cache.tint[ck];
      var w = srcCanvas.width, h = srcCanvas.height;
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d');
      x.drawImage(srcCanvas, 0, 0);
      x.globalCompositeOperation = 'source-in';
      x.fillStyle = color; x.fillRect(0, 0, w, h);
      cache.tint[ck] = c;
      return c;
    }

    renderOutline(cx, cy, S, bf, dx, dy, faceImg) {
      var ctx = this.ctx;
      var box = S * 0.62;
      var oc = this.buildOutline(box, faceImg);
      var MB = oc.MBcss;
      var ox = cx - MB / 2, oy = cy - MB / 2;
      var place = function (canv, offx, offy) { ctx.drawImage(canv, ox + offx, oy + offy, MB, MB); };

      // glow halo around the whole connected panel
      ctx.save();
      ctx.shadowColor = rgbaStr(this.primary, 0.4 * bf + 0.16);
      ctx.shadowBlur = S * 0.05;
      var glow = this.outlineTint(oc, oc.dil, this.primary, 'dil');
      place(glow, dx * 0.5, dy * 0.5);
      place(glow, dx * 0.5, dy * 0.5);
      ctx.restore();

      // drop shadow
      ctx.save();
      ctx.globalAlpha = 0.42;
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = S * 0.035;
      place(this.outlineTint(oc, oc.dil, '#0e0e0e', 'dil'), dx + S * 0.012, dy + S * 0.018);
      ctx.restore();

      // extruded glowing side, built from the single connected panel
      var STEPS = 56;
      for (var i = STEPS; i >= 1; i--) {
        var t = i / STEPS;
        var sc = this.stripeColor(t);
        var col = sc.c === 'PRIMARY' ? this.primary : sc.c;
        ctx.save();
        if (sc.glow) { ctx.shadowColor = rgbaStr(col, 0.30 + 0.4 * bf); ctx.shadowBlur = S * 0.012; }
        place(this.outlineTint(oc, oc.dil, col, 'dil'), dx * t, dy * t);
        ctx.restore();
      }

      // front: customer-chosen background (mat) colour as one solid piece, then the printed logo art
      place(this.outlineTint(oc, oc.dil, this.bgColor || '#f6f3ec', 'dil'), 0, 0);
      place(oc.mask, 0, 0);
    }
  }

  customElements.define('logo-preview-component', LogoPreview);
})();
